import { render, staticRenderFns } from "./SkeletonPlanBox.vue?vue&type=template&id=6eb99956&scoped=true&"
import script from "./SkeletonPlanBox.vue?vue&type=script&lang=js&"
export * from "./SkeletonPlanBox.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonPlanBox.vue?vue&type=style&index=0&id=6eb99956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb99956",
  null
  
)

export default component.exports